import { render, staticRenderFns } from "./EvrakEkleForm.vue?vue&type=template&id=4f44dc58"
import script from "./EvrakEkleForm.vue?vue&type=script&lang=ts"
export * from "./EvrakEkleForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports